<template>
    <div class="main1" :style="vh">
        <div v-if="!isPc" style="position: relative;top:-0.5rem">
        <navHeader v-if="activeIndex!=3||activeIndex==3&&isPc" :type="navType"></navHeader>
        </div>
        <div v-if="isPc">
            <navHeader v-if="activeIndex!=3||activeIndex==3&&isPc" :type="navType"></navHeader>
        </div>
        <div class="swiper-container" :style="vh" id="swiperIndex">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="all1" :style="vh">
                        <video muted autoplay loop v-if="isPc&&content.picturePageVos" :src="baseUrl+content.picturePageVos[0].path" class="big"></video>
                        <img @load="getImg" v-if="content.picturePageVos&&!isPc" class="big" :src="baseUrl+content.picturePageVos[3].path" alt="">
                        <div class="phone" v-if="isPc">客服热线：010-58701668（北京）、028-68517888（四川）投诉邮箱：service@zx017.com
                        </div>
                        <div class="phone1" v-if="!isPc">
                            <div>北京: 010-58701668<span>四川: 028-68517888</span></div>
                            <div>投诉: 010-58701766<span>投诉: 028-68284100</span></div>
                        </div>
                        <div class="center">
                            <div class="top">
                                <span>用心专注</span><span>成就财富</span>
                            </div>
                            <div class="btm" v-if="isPc">专注于证券投资顾问服务领域 追求客户财富的保值与增值</div>
                            <div class="btm1" v-if="!isPc">
                                <div>专注于证券投资顾问服务领域</div>
                                <div>追求客户财富的保值与增值</div>
                            </div>
                        </div>
                        <div v-show="isPc" class="func">
                            <div class="item" @mouseenter="phoneShow = true" @mouseleave="phoneShow = false">
                                <div class="top">
                                    <div class="bd1"></div>
                                    客户服务电话
                                    <div class="bd2"></div>
                                </div>
                                <div style="height:1.85rem;">
                                    <Transition name="phoneShow">
                                        <div class="btm" v-if="phoneShow">
                                            <div class="i1">
                                                <div class="lf">北京</div>
                                                <div class="ri">
                                                    <div class="t">公司电话: 010-58701668</div>
                                                    <div class="b">投诉电话: 010-58701766</div>
                                                </div>
                                            </div>
                                            <div class="i1">
                                                <div class="lf">四川</div>
                                                <div class="ri">
                                                    <div class="t">公司电话: 028-68517888</div>
                                                    <div class="b">投诉电话: 028-68284100</div>
                                                </div>
                                            </div>
                                        </div>
                                    </Transition>
                                </div>
                            </div>
                            <div class="item" @mouseenter="msgShow = true" @mouseleave="msgShow = false">
                                <div class="top">
                                    <div class="bd1"></div>
                                    企业信息
                                    <div class="bd2"></div>
                                </div>
                                <div style="height:1.85rem;">
                                    <Transition name="msgShow">
                                        <div class="btm" v-if="msgShow">
                                            <div style="cursor: pointer;" @click="goPage(item)"
                                                v-for="item in content.enterInfo" :key="item.columnId" class="i2">
                                                {{item.columnName}}
                                            </div>
                                        </div>
                                    </Transition>
                                </div>
                            </div>
                            <div class="item" @mouseenter="appShow = true" @mouseleave="appShow = false">
                                <div class="top">
                                    <div class="bd1"></div>
                                    APP下载
                                    <div class="bd2"></div>
                                </div>
                                <div style="height:1.85rem;">
                                    
                                    <Transition name="appShow">
                                        <div class="btm" v-show="appShow">
                                            <div class="i3">
                                                <div class="lf">
                                                    <div ref="wd" style="width: 1.2rem;height: 1.2rem;">
                                                        <div class="code" ref="qrcode1"></div>
                                                    </div>
                                                    <div class="wz">AppStore下载</div>
                                                </div>
                                                <div class="ri">
                                                    <div style="width: 1.2rem;height: 1.2rem;">
                                                        <div class="code" ref="qrcode2"></div>
                                                    </div>
                                                    <div class="wz">Android下载</div>
                                                </div>
                                            </div>
                                        </div>
                                    </Transition>
                                </div>
                            </div>
                        </div>
                        <div v-show="!isPc" class="func1">
                            <div class="item">
                                <div class="top">
                                    <div class="bd1"></div>
                                    APP下载
                                    <div class="bd2"></div>
                                </div>
                                <div>
                                    <div class="btm">
                                        <div class="i3">
                                            <div class="lf">
                                                <div ref="wd1" style="width: 1.6rem;height: 1.6rem;">
                                                        <div class="code" ref="qrcode3"></div>
                                                    </div>
                                                <div class="wz">AppStore下载</div>
                                            </div>
                                            <div class="ri">
                                                <div style="width: 1.6rem;height: 1.6rem;">
                                                        <div class="code" ref="qrcode4"></div>
                                                    </div>
                                                <div class="wz">Android下载</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <img v-if="goShow" @click="goNext" class="next" src="../assets/imgs/xx.png" alt="">
                    </div>
                </div>
                <div class="swiper-slide" style="position: relative;">
                    <div class="all2" v-if="content.picturePageVos"
                        :style="'background:url('+baseUrl+content.picturePageVos[1].path+') center no-repeat;background-size: cover;'">
                        <div class="wz">
                            <div class="title">北京中富金石咨询有限公司</div>
                            <div v-if="isPc" style="height: 2.2rem;position: relative;overflow: hidden;">
                                <Transition name="descShow">
                                    <div class="cont" @click="changeDesc" v-if="!descShow1">
                                        <div>成立于<span>1997年</span></div>
                                        <div>是中国证监会批准的专业证券投资咨询机构</div>
                                        <div>目前公司是中国证券业协会<span>会员单位</span></div>
                                    </div>
                                </Transition>
                                <Transition name="descShow1">
                                    <div class="cont1" @click="changeDesc" v-if="descShow1">
                                        公司挟十多年资本市场投行之经验，开展证券投资顾问业务，力争向投资者倡导价值投资理念，传播科学投资方法，为投资者证券决策提供专业的投资顾问支持
                                    </div>
                                </Transition>
                            </div>
                            <div v-if="!isPc">
                                    <div class="cont">
                                        <div>成立于<span>1997年</span></div>
                                        <div>是中国证监会批准的专业证券投资咨询机构</div>
                                        <div>目前公司是中国证券业协会<span>会员单位</span></div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="swip">
                        <div class="tp">
                            <div style="width: 100%;height: 100%;" class="swiper-container" id="swiperIndex1">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <div class="itm1">
                                            <div class="t">企业信息</div>
                                            <div class="b">
                                                <div style="cursor: pointer;" @click="goPage(item)"
                                                    v-for="item in content.enterInfo" :key="item.columnId" class="i2">
                                                    {{item.columnName}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="itm2">
                                            <div class="t">客服电话</div>
                                            <div class="b">
                                                <div>北京公司：010-58701668</div>
                                                <div>四川公司：028-68517888</div>
                                            </div>
                                            <div class="b">
                                                <div>投诉电话：010-58701766</div>
                                                <div>投诉电话：028-68284100</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="itm3">
                                            <div class="t">APP下载</div>
                                            <div class="b">
                                                <div class="i">
                                                    <div ref="wd1" style="width: 0.96rem;height: 0.96rem;margin-right: 0.2rem;">
                                                        <div class="code" ref="qrcode5"></div>
                                                    </div>
                                                    <div>AppStore下载</div>
                                                </div>
                                                <div class="i">
                                                    <div ref="wd1" style="width: 0.96rem;height: 0.96rem;margin-right: 0.2rem;">
                                                        <div class="code" ref="qrcode6"></div>
                                                    </div>
                                                    <div>Android下载</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bm">
                            <div class="l" @click="goPrev1">
                                <img src="../assets/imgs/gol.png" alt="">
                                <span>上一个</span>
                            </div>
                            <div class="r" @click="goNext1">
                                <img src="../assets/imgs/gor.png" alt="">
                                <span>下一个</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="all3" v-if="isPc&&content.picturePageVos">
                        <Transition name="photoShow1">
                            <img v-show="showPhoto" :src="baseUrl+content.picturePageVos[2].path" alt="">
                        </Transition>
                        <Transition name="photoShow2">
                            <div class="wz" v-if="showPhoto">
                                <span>中富金石</span>研究团队依托于深厚的研究实力以及全体投资顾问团队成员多年科学、专业的实战投资智慧，针对机构大客户和资产量较大的个人投资者提供专业的投资顾问服务。
                                <div style="margin-top: 0.16rem;">根据客户资产状况以及风险承受能力，为其量身定制个性化投资方案，并对持仓个股进行全程追踪、指导，运用科学、理性的投资方法，力求在风险可控的前提下实现财富增值的投资目标！</div>
                                
                            </div>
                        </Transition>
                    </div>
                    <div class="all31" v-if="!isPc">
                        <img v-if="content.picturePageVos" :src="baseUrl+content.picturePageVos[2].path" alt="">
                        <div class="wz">
                            <span>中富金石</span>研究团队依托于深厚的研究实力以及全体投资顾问团队成员多年科学、专业的实战投资智慧，针对机构大客户和资产量较大的个人投资者提供专业的投资顾问服务。
                            <div style="margin-top: 0.1rem;">根据客户资产状况以及风险承受能力，为其量身定制个性化投资方案，并对持仓个股进行全程追踪、指导，运用科学、理性的投资方法，力求在风险可控的前提下实现财富增值的投资目标！</div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="all4" :style="vh">
                        <div class="fix">
                            <navFooter></navFooter>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cotice"  ref="thediv" @click="openCotice" v-show="thedivShow">
            <span class="close-cotice" @click.stop="closeCotice">X</span>
            <img  src="../assets/imgs/cotice2.png" alt="">
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import { getIndex } from "../api/index"
import navHeader from "../components/header.vue"
import navFooter from "../components/footer.vue"
import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swiper
export default {
    name: 'index',
    components: {
        navHeader,
        navFooter
    },
    data() {
        return {
            gifShow:false,
            can:true,
            vh:0,
            baseUrl: this.$store.state.baseUrl,
            content: {},
            activeIndex: 0,
            isPc: 1,
            destimer: null,
            goShow: false,
            navType: 2,
            showPhoto: false,
            descShow1: false,
            mySwiper: null,
            mySwiper1: null,
            phoneShow: false,
            msgShow: false,
            appShow: false,
            xPos: 0,
            yPos: 0,
            xin: true,
            yin: true,
            step: 3,
            delay: 30,
            height: 0,
            Hoffset: 0,
            Woffset: 0,
            yon: 0,
            xon: 0,
            pause: true,
            thedivShow: false,

        }
    },
    watch: {
        '$store.state.isPc'(newVal, oldVal) {
            this.isPc = newVal
        }
    },
    created() {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
            "SymbianOS", "Windows Phone", "iPod"];
        var isPc = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                isPc = false;
                break;
            }
        }
        if (isPc) {
            this.isPc = 1
            this.$store.commit('setIspc', 1)

        } else {
            this.isPc = 0
            this.$store.commit('setIspc', 0)
        }
    },
    mounted() {
        if(this.isPc){
            this.vh="height:100vh"
        }else{
            var vh=window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
            this.vh = "height:"+vh+"px"
        }
        
        this.$nextTick(()=>{
            this.mySwiper = new Swiper("#swiperIndex", {
            direction: 'vertical',
            mousewheel: true,
            speed: 800,
            thresholdTime:2000,
            watchSlidesProgress: true,
            on: {
                slideChange: function () {
                    // console.log(this.activeIndex)
                    if (this.activeIndex == 0) {
                        that.navType = 2
                    } else {
                        that.navType = 3
                    }
                    if (this.activeIndex == 1) {
                        that.mySwiper.mousewheel.disable()
                    } else {
                        that.mySwiper.mousewheel.enable()
                    }
                    if (this.activeIndex == 2) {
                        setTimeout(() => {
                            that.showPhoto = true
                        }, 200)
                    } else {
                        that.showPhoto = false
                    }
                },
                slideChangeTransitionEnd: function(){
                    that.activeIndex = this.activeIndex
                    that.can=true
          
        },
            },
        });
        })
        window.addEventListener('mousewheel',this.handleScroll, 100, true)
        var that = this
        setTimeout(() => {
            this.goShow = true
        }, 200)
        
        this.mySwiper1 = new Swiper("#swiperIndex1", {
            loop: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            }, //fade属性必须加上
            on: {
                resize: function () {
                    setTimeout(() => {
                        this.update(); //窗口变化时，更新Swiper的一些属性，如宽高等
                    }, 500)

                },
            },

        });
        this.$nextTick(()=>{
            this.getIndex()
        })
        
        this.interval = setInterval(this.changePos, this.delay);            

    },
    beforeDestory() {
        clearInterval(this.destimer)
    },
    methods: {
        changePos(){
            let width = document.documentElement.clientWidth;
            let height = document.documentElement.clientHeight;
            if (this.$refs.thediv) {
                this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
                this.Woffset = this.$refs.thediv.offsetWidth;
                // 滚动部分不随屏幕滚动
                this.$refs.thediv.style.left =
                this.xPos + document.body.scrollLeft + "px";
                this.$refs.thediv.style.top =
                this.yPos + document.body.scrollTop + "px";
        
                if (this.yon) {
                this.yPos = this.yPos + this.step;
                } else {
                this.yPos = this.yPos - this.step;
                }
                if (this.yPos < 0) {
                this.yon = 1;
                this.yPos = 0;
                }
                if (this.yPos >= height - this.Hoffset) {
                this.yon = 0;
                this.yPos = height - this.Hoffset;
                }
        
                if (this.xon) {
                this.xPos = this.xPos + this.step;
                } else {
                this.xPos = this.xPos - this.step;
                }
                if (this.xPos < 0) {
                this.xon = 1;
                this.xPos = 0;
                }
                if (this.xPos >= width - this.Woffset) {
                this.xon = 0;
                this.xPos = width - this.Woffset;
                }
            }
        },
        getImg(){
            this.gifShow=true
        },
        goPage(item) {
            // console.log(item)
            if(item.columnId=="JJ20220940"){
                this.$router.push("/staff")
            }else{
                this.$router.push("/firm") 
            }
            
        },
        // 获取首页信息
        getIndex() {
            getIndex().then(res => {
                // console.log(res.data)
                res.data.enterInfo.pop()
                this.content = res.data
                this.getEwm(res.data.appStore)
                this.getEwm1(res.data.android)
            }).catch(err => {
                console.log(err)
            })
        },
        getEwm(url){
            var size1 = document.documentElement.style.fontSize.slice(0,-2)*1.6
            var size2 = document.documentElement.style.fontSize.slice(0,-2)*0.96
            let qrcode = new QRCode(this.$refs.qrcode1,{
                text: url // 设置二维码内容或跳转地址
                })
                let qrcode5 = new QRCode(this.$refs.qrcode5,{
                    width:size2,
                height:size2, 
                text: url // 设置二维码内容或跳转地址
                })
                let qrcode3 = new QRCode(this.$refs.qrcode3,{
                width:size1,
                height:size1,  
                text: url // 设置二维码内容或跳转地址
                })
        },
        getEwm1(url){
            var size1 =document.documentElement.style.fontSize.slice(0,-2)*1.6
            var size2 = document.documentElement.style.fontSize.slice(0,-2)*0.96
            let qrcode2 = new QRCode(this.$refs.qrcode2,{
                text: url // 设置二维码内容或跳转地址
                })
                let qrcode6 = new QRCode(this.$refs.qrcode6,{
                    width:size2,
                height:size2, 
                text: url // 设置二维码内容或跳转地址
                })
                let qrcode4 = new QRCode(this.$refs.qrcode4,{
                    width:size1,
                height:size1,
                text: url // 设置二维码内容或跳转地址
                })
        },
        //函数防抖
        debounce(func, wait) {
            let timeout;
            return function () {
                let context = this;
                let args = arguments;
                if (timeout) clearTimeout(timeout);
                timeout = setTimeout(() => {
                    func.apply(context, args)
                }, wait);
            }
        },
        //判断滚动方向
        handleScroll(e) {
            let direction = e.deltaY > 0 ? 'down' : 'up'
            if (this.activeIndex == 1 && direction == "up") {
                // console.log(direction)
                this.mySwiper.slidePrev();
            }
            if (this.activeIndex == 1 && direction == "down") {
                // console.log(direction)
                if (!this.descShow1) {
                    this.descShow1 = true
                } else {
                    if(this.can){
                        this.mySwiper.slideNext();
                        this.can=false

                    }
                        

                }

            }
        },
        changeDesc() {
            this.descShow1 = !this.descShow1
        },
        goPrev1() {
            this.mySwiper1.slidePrev()
        },
        goNext1() {
            this.mySwiper1.slideNext()
        },
        // 首页下一页
        goNext() {
            this.mySwiper.slideNext()
        },
        openCotice() {
            window.location.href = "https://www.zx017.com/article/317"
        },
        closeCotice() {
            this.thedivShow = false
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.main1 {
    position: relative;
    width: 100%;
    height: 100vh;
}

.swiper-container {
    width: 100%;
}

@media (min-width:500px) {
    .all1 {
        width: 100%;
        position: relative;
        background: #061456;

        .big {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }

        .phone {
            white-space: nowrap;
            position: absolute;
            top: 0.26rem;
            right: 1.98rem;
            font-size: 0.21rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }

        .center {
            top: 2.5rem;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            white-space: nowrap;
            background: rgba(0, 0, 0, 0.2);
            padding: 0.75rem 1.5rem 0.66rem;
            margin-bottom: 1.62rem;

            .top {
                text-align: center;
                font-size: 0.6rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #FFFFFF;
                letter-spacing: 0.18rem;

                span:nth-child(1) {
                    margin: 0.38rem;
                }
            }

            .btm {
                margin-top: 0.5rem;
                font-size: 0.36rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                letter-spacing: 0.03rem;
            }
        }

        .func {
            width: 13rem;
            position: absolute;
            bottom: 0.6rem;
            left: 50%;
            transform: translateX(-50%);
            color: #fff;
            display: flex;
            justify-content: space-between;

            .item {
                width: 3.46rem;
            }

            .top {
                display: flex;
                align-items: center;
                font-size: 0.36rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                letter-spacing: 0.03rem;
                text-shadow: 0rem 0.06rem 0.12rem rgba(0, 0, 0, 0.3);

                .bd1 {
                    border-top: 0.02rem solid #fff;
                    width: 0.36rem;
                    margin-right: 0.18rem;
                }

                .bd2 {
                    border-top: 0.02rem solid #fff;
                    width: 0.36rem;
                    margin-left: 0.18rem;
                }
            }

            .btm {
                overflow: hidden;
                width: 3.66rem;

                .i1 {
                    padding-top: 0.3rem;
                    display: flex;
                    align-items: center;

                    .lf {
                        font-size: 0.27rem;
                        font-family: PingFang SC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #FFFFFF;
                        letter-spacing: 0.02rem;
                        flex: 1
                    }

                    .ri {
                        font-size: 0.21rem;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        letter-spacing: 0.02rem;

                        .t {
                            margin-bottom: 0.1rem;
                        }
                    }
                }

                .i2 {
                    padding-top: 0.3rem;
                    font-size: 0.27rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                    letter-spacing: 0.02rem;

                }

                .i3 {
                    padding-top: 0.3rem;
                    display: flex;
                    align-items: flex-start;

                    .wz {
                        padding-top: 0.18rem;
                        font-size: 0.21rem;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        letter-spacing: 0.02rem;
                    }
                    .lf{
                        margin-right: 0.1rem;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .ri{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }

                }
            }
        }

        .next {
            animation:myanimation 2.3s infinite;
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            bottom: 0.36rem;
            width: 0.5rem;
            height: 0.54rem;
        }
        @keyframes myanimation {
            0% {bottom:0.36rem;}
            25% {bottom:0.1rem;}
            50% {bottom:0.36rem;}
            75% {bottom:0.1rem;}
            100% {bottom:0.36rem;}
        }

    }

    .swip {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 6.24rem;

        .tp {
            height: 2.25rem;
            background: #3559C7;

            .itm1 {
                width: 100%;
                height: 100%;

                .t {
                    padding: 0.3rem 0;
                    font-size: 0.3rem;
                    text-align: center;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                }

                .b {
                    display: flex;
                    justify-content: space-evenly;
                    font-size: 0.36rem;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }

            .itm2 {
                width: 100%;
                height: 100%;

                .t {
                    padding: 0.3rem 0;
                    font-size: 0.3rem;
                    text-align: center;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                }

                .b {
                    display: flex;
                    justify-content: space-evenly;
                    font-size: 0.21rem;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-bottom: 0.15rem;
                    overflow: hidden;
                }
            }

            .itm3 {
                width: 100%;
                height: 100%;

                .t {
                    padding: 0.3rem 0;
                    font-size: 0.3rem;
                    text-align: center;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                }

                .b {
                    display: flex;
                    justify-content: center;
                    font-size: 0.21rem;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-bottom: 0.15rem;
                    overflow: hidden;

                    img {
                        width: 0.96rem;
                        height: 0.96rem;
                        margin-right: 0.12rem;
                    }

                    .i {
                        display: flex;
                        align-items: center;
                    }

                    .i:nth-child(1) {
                        margin-right: 0.3rem;
                    }
                }
            }
        }

        .bm {
            display: flex;
            height: 0.6rem;
            background: #292E3D;
            font-size: 0.27rem;
            font-family: Work Sans-Regular, Work Sans;
            font-weight: 400;
            color: #FFFFFF;

            img {
                width: 0.39rem;
                height: 0.25rem;
                margin-right: 0.15rem;
            }

            .l {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 50%;
                border-right: 0.02rem solid #fff;
            }

            .r {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 50%;
            }
        }
    }

    .all2 {
        width: 100%;
        height: 100%;
        position: relative;



        .wz {
            position: absolute;
            top: 2.7rem;
            left: 1.2rem;

            .title {
                font-size: 0.72rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #292E3D;
                margin-bottom: 0.6rem;
            }

            .cont {
                position: absolute;
                top: 0;
                left: 0;
                font-size: 0.36rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #292E3D;

                div {
                    margin-bottom: 0.24rem;

                    span {
                        color: #D7000F;
                    }
                }
            }

            .cont1 {
                position: absolute;
                top: 0;
                left: 0;
                width: 8.7rem;
                font-size: 0.36rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.75);
                line-height: 0.55rem;
                letter-spacing: 0.03rem;
            }
        }
    }

    .all3 {
        width: 100%;
        height: 100%;
        position: relative;

        img {
            width: 9.27rem;
            height: 6.88rem;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 1.8rem;
        }

        .wz {
            left: 50%;
            width: 7.65rem;
            height: 4.71rem;
            padding: 0.6rem 0.48rem;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: #2947A9;
            font-size: 0.24rem;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 300;
            color: #FFFFFF;
            line-height: 0.42rem;
            letter-spacing: 0.03rem;

            span {
                font-size: 0.36rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
            }
        }
    }

    .all4 {
        overflow: hidden;
        width: 100%;
        height: 100%;
        position: relative;

        .fix {
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
        }
    }
}

@media (max-width:500px) {
    .all1 {
        width: 100%;
        position: relative;
        background: #061456;

        .big {
            height: 100%;
            object-fit: cover;
            width: 100%;
        }

        .phone1 {
            white-space: nowrap;
            position: absolute;
            top: 1.76rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.28rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;

            span {
                margin-left: 0.98rem;
            }
        }

        .center {
            bottom: 5.6rem;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            white-space: nowrap;
            background: rgba(0, 0, 0, 0.2);
            padding: 0.62rem 1.36rem 0.32rem;

            .top {
                text-align: center;
                font-size: 0.48rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #FFFFFF;
                letter-spacing: 0.02rem;

                span:nth-child(1) {
                    margin: 0.18rem;
                }
            }

            .btm {
                margin-top: 0.5rem;
                font-size: 0.36rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                letter-spacing: 0.03rem;
            }

            .btm1 {
                text-align: center;
                margin-top: 0.24rem;
                font-size: 0.28rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
            }

            .btm1>div:nth-child(1) {
                margin-bottom: 0.01rem;
            }
        }

        .func1 {
            position: absolute;
            bottom: 1.72rem;
            left: 50%;
            transform: translateX(-50%);
            color: #fff;

            .top {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.34rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                text-shadow: 0rem 0.08rem 0.16rem rgba(0, 0, 0, 0.3);

                .bd1 {
                    border-top: 0.02rem solid #fff;
                    width: 0.36rem;
                    margin-right: 0.18rem;
                }

                .bd2 {
                    border-top: 0.02rem solid #fff;
                    width: 0.36rem;
                    margin-left: 0.18rem;
                }
            }

            .btm {
                .i3 {
                    padding-top: 0.35rem;
                    display: flex;
                    align-items: center;

                    .wz {
                        padding-top: 0.24rem;
                        font-size: 0.28rem;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        letter-spacing: 0.01rem;
                    }


                    .lf {
                        width: 2.04rem;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-right: 0.3rem;
                    }

                    .ri {
                        width: 2.04rem;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }

                }
            }
        }



        .next {
            animation:myanimation 2.3s infinite;
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            bottom: 0.36rem;
            width: 0.7rem;
            height: 0.8rem;
        }
        @keyframes myanimation {
            0% {bottom:0.36rem;}
            25% {bottom:0.1rem;}
            50% {bottom:0.36rem;}
            75% {bottom:0.1rem;}
            100% {bottom:0.36rem;}
        }
    }

    .swip {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;

        .tp {
            height: 2.24rem;
            background: #3559C7;

            .itm1 {
                width: 100%;
                height: 100%;

                .t {
                    padding: 0.4rem 0;
                    font-size: 0.3rem;
                    text-align: center;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                }

                .b {
                    display: flex;
                    justify-content: space-evenly;
                    font-size: 0.34rem;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }

            .itm2 {
                width: 100%;
                height: 100%;

                .t {
                    padding: 0.25rem 0;
                    font-size: 0.3rem;
                    text-align: center;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                }

                .b {
                    display: flex;
                    justify-content: space-evenly;
                    font-size: 0.21rem;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-bottom: 0.15rem;
                    overflow: hidden;
                }
            }

            .itm3 {
                width: 100%;
                height: 100%;

                .t {
                    padding: 0.25rem 0;
                    font-size: 0.3rem;
                    text-align: center;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                }

                .b {
                    display: flex;
                    justify-content: center;
                    font-size: 0.21rem;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    overflow: hidden;

                    img {
                        width: 0.96rem;
                        height: 0.96rem;
                        margin-right: 0.12rem;
                    }

                    .i {
                        display: flex;
                        align-items: center;
                    }

                    .i:nth-child(1) {
                        margin-right: 0.3rem;
                    }
                }
            }
        }

        .bm {
            display: flex;
            height: 0.8rem;
            background: #292E3D;
            font-size: 0.36rem;
            font-family: Work Sans-Regular, Work Sans;
            font-weight: 400;
            color: #FFFFFF;

            img {
                width: 0.52rem;
                height: 0.34rem;
                margin-right: 0.2rem;
            }

            .l {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 50%;
                // border-right: 0.02rem solid #fff;
            }

            .r {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 50%;
            }
        }
    }

    .all2 {
        width: 100%;
        height: 100%;
        position: relative;



        .wz {
            width: 92%;
            position: absolute;
            top: 2.56rem;
            left: 0.32rem;

            .title {
                font-size: 0.48rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #292E3D;
                margin-bottom: 0.48rem;
            }

            .cont {
                // position: absolute;
                top: 0;
                left: 0;
                font-size: 0.34rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #292E3D;

                div {
                    margin-bottom: 0.24rem;

                    span {
                        color: #D7000F;
                    }
                }
            }

            .cont1 {
                position: absolute;
                top: 0;
                left: 0;
                font-size: 0.34rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.75);
                line-height: 0.6rem;
                letter-spacing: 0.01rem;
            }
        }
    }

    .all31 {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;

        img {
            width: 100%;

        }

        .wz {
            flex: 1;
            padding: 1.02rem 0.48rem;
            background: #2947A9;
            font-size: 0.32rem;
            font-family: PingFang SC-Semibold, PingFang SC;
            color: #FFFFFF;
            line-height: 0.6rem;
            font-weight: 300;
            letter-spacing: 0.03rem;

            span {
                font-size: 0.48rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
            }
        }

        .next {
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            bottom: 0.48rem;
            width: 1.02rem;
            height: 1.02rem;
        }
    }

    .all4 {
        width: 100%;
        height: 100%;
        position: relative;

        .fix {
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
        }
    }

    .main1 .cotice{
        position: fixed;
        bottom: 0;
        right: 0;
        width: 5rem;
        height: 1.29rem;
        z-index: 10;
        cursor: pointer;
    }
    .main1 .close-cotice{
        position: absolute;
        top: -0.42rem;
        right: 0;
        padding: 0 0.18rem;
        font-size: 0.3rem;
        color: #FFFFFF;
        background-color: #999;
        border-radius: 0.3rem;
    }
    .main1 .cotice img{
        display: block;
        width: 5rem;
        height: 1.29rem;
    }

}

.phoneShow-enter-active {
    animation: phoneShow-in 0.3s;
}

.phoneShow-leave-active {
    animation: phoneShow-in 0.3s reverse;
}

@keyframes phoneShow-in {
    0% {
        height: 0;
    }

    100% {
        height: 100%;
    }
}

.msgShow-enter-active {
    animation: msgShow-in 0.3s;
}

.msgShow-leave-active {
    animation: msgShow-in 0.3s reverse;
}

@keyframes msgShow-in {
    0% {
        height: 0;
    }

    100% {
        height: 100%;
    }
}

.appShow-enter-active {
    animation: appShow-in 0.3s;
}

.appShow-leave-active {
    animation: appShow-in 0.3s reverse;
}

@keyframes appShow-in {
    0% {
        height: 0;
    }

    100% {
        height: 100%;
    }
}

.descShow-enter-active {
    animation: descShow-in 0.4s;
}

.descShow-leave-active {
    animation: descShow-in 0.4s reverse;
}

@keyframes descShow-in {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.descShow1-enter-active {
    animation: descShow1-in 0.4s;
}

.descShow1-leave-active {
    animation: descShow1-in 0.4s reverse;
}

@keyframes descShow1-in {
    0% {
        top: 2.2rem;
        opacity: 0;
    }

    100% {
        top: 0;
        opacity: 1;
    }
}

.photoShow1-enter-active {
    animation: photoShow1-in 0.4s;
}

.photoShow1-leave-active {
    animation: photoShow1-in 0.4s reverse;
}

@keyframes photoShow1-in {
    0% {
        left: -9.27rem;
        opacity: 0;
    }

    100% {
        left: 1.8rem;
        opacity: 1;
    }
}

.photoShow2-enter-active {
    animation: photoShow2-in 0.4s;
}

.photoShow2-leave-active {
    animation: photoShow2-in 0.4s reverse;
}

@keyframes photoShow2-in {
    0% {
        left: 100vw;
        opacity: 0;
    }

    100% {
        left: 50%;
        opacity: 1;
    }
}

.go-enter-active {
    animation: go-in 2s ease;
}

@keyframes go-in {
    0% {
        bottom: 0.36rem;
    }

    25% {
        bottom: 0.1rem;
    }

    50% {
        bottom: 0.36rem;
    }

    75% {
        bottom: 0.1rem;
    }

    100% {
        bottom: 0.36rem;
    }
}

.cotice{
    position: fixed;
    bottom: 0;
    right: 0;
    width: 398px;
    height: 144px;
    z-index: 10;
    cursor: pointer;
}
.close-cotice{
    position: absolute;
    top: -34px;
    right: 0;
    padding: 0 8px;
    font-size: 24px;
    color: #FFFFFF;
    background-color: #999;
    border-radius: 30px;
}
.cotice img{
    display: block;
    width: 398px;
    height: 144px;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue